import React from 'react';
import styles from '../styles.module.css';
import { shopServiceType } from '@/commonTypes';
import MainIcons from '@/icons/main';
import SectionHead from '@/components/general/SectionHead';
import ServiceMeta from './ServiceMeta';
import Gallery from '@/components/pages/product/SingleProductContent/Gallery';

export default function ServiceShopHeroInfo({ data }: { data?: shopServiceType }) {
  const warranty = data?.attributes?.find((x) => x.attributeSlug == 'warranty');
  return (
    <div className={`${styles.shopHeroInfo}`}>
      <div className={`${styles.badges}`}>
        {data?.category && (
          <span className={`badge orangeBadgeDark `}>
            <MainIcons.homeIcon width="13px" height="13px" fill="rgb(255, 176, 122)" />
            {data?.category?.title}
          </span>
        )}
        {warranty && (
          <span className={`badge warrantyBadgeDark `}>
            <MainIcons.shieldIcon width="13px" height="13px" fill="var(--green)" />
            {`گارانتی  ${warranty?.value}`}
          </span>
        )}
        {data?.inPlace && (
          <span className={`badge mobileBadgeDark `}>
            <MainIcons.homeIcon width="13px" height="13px" fill="rgb(192, 176, 255)" />
            {'قابل انجام در محل شما'}
          </span>
        )}
      </div>
      <SectionHead
        title={data?.title}
        text={data?.description}
        titleClass={styles.serviceHeroTitleClass}
        textTitle={styles.serviceHeroTextClass}
      />
      <ServiceMeta data={data} />
      <Gallery data={data} className={`${styles.gallery}`} />
    </div>
  );
}
